export const formatRouteString = (route: string): string => {
    const lastSegment = route.split('/').pop();

    if (!lastSegment) return '';

    return lastSegment
        .split('-')
        .map(word => word.charAt(0).toUpperCase() + word.slice(1))
        .join(' ');
};


export const formatKey = (key: string) => {
    return key.replace(/_/g, ' ').replace(/\b\w/g, char => char.toUpperCase());
};



type Range = {
    min: number;
    max: number;
};

export const parseRange = (input: string): Range | null => {
    const match = input.match(/^(\d+)-(\d+)$/);
    if (!match) return null;

    const [, minStr, maxStr] = match;
    const min = parseInt(minStr, 10);
    const max = parseInt(maxStr, 10);

    return { min, max };
};


export function formatTimeRange(start: string, end: string): string {
    const options: Intl.DateTimeFormatOptions = {
        hour: 'numeric',
        minute: '2-digit',
        hour12: true,
        timeZone: 'Asia/Tehran',
    };

    const startDate = new Date(start);
    const endDate = new Date(end);

    const startTime = startDate.toLocaleTimeString('en-US', options);
    const endTime = endDate.toLocaleTimeString('en-US', options);

    return `${startTime} - ${endTime}`;
};

export function formatTo12Hour(timeString: string): string {
    const date = new Date(timeString);

    if (isNaN(date.getTime())) {
        return 'Invalid Date';
    }

    let hours = date.getHours();
    const minutes = date.getMinutes();
    const ampm = hours >= 12 ? 'PM' : 'AM';

    hours = hours % 12;
    hours = hours ? hours : 12; // ساعت 0 یعنی 12
    const minutesStr = minutes < 10 ? '0' + minutes : minutes.toString();
    const hoursStr = hours < 10 ? '0' + hours : hours.toString();

    return `${hoursStr}:${minutesStr} ${ampm}`;
};

export const countTrues = (boolArray: boolean[]): number => {
    return boolArray.filter(value => value).length;
};

// utils/formatDate.ts
export const formatDate = (inputDate: string): string => {
    const dt = new Date(inputDate);

    const options: Intl.DateTimeFormatOptions = {
        day: '2-digit',
        month: 'short',
        year: 'numeric',
        hour: '2-digit',
        minute: '2-digit',
        hour12: false,
    };

    return dt.toLocaleString('en-GB', options).replace(',', ' -');
};
